import { SubjectsForm } from "../../components/Forms/";

const NewSubjects = () => {
  return <SubjectsForm />;
};

export default NewSubjects;
